// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b017a093","897":"b03da0b0"}[chunkId] + ".chunk.js";
};